var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 10.6664C5.62287 10.6665 5.57948 10.658 5.53899 10.6413C5.49849 10.6246 5.46169 10.6 5.43067 10.5691L0.764006 5.90244C0.732964 5.87147 0.708335 5.83469 0.691531 5.79419C0.674726 5.7537 0.666077 5.71028 0.666077 5.66644C0.666077 5.62259 0.674726 5.57918 0.691531 5.53868C0.708335 5.49818 0.732964 5.4614 0.764006 5.43044L5.43067 0.76377C5.49326 0.701179 5.57816 0.666016 5.66667 0.666016C5.75519 0.666016 5.84008 0.701179 5.90267 0.76377C5.96526 0.826361 6.00043 0.911253 6.00043 0.99977C6.00043 1.08829 5.96526 1.17318 5.90267 1.23577L1.47134 5.66644L5.90267 10.0971C5.94941 10.1437 5.98125 10.2032 5.99416 10.2679C6.00708 10.3326 6.00047 10.3998 5.9752 10.4607C5.94992 10.5217 5.9071 10.5738 5.85217 10.6104C5.79725 10.6471 5.73269 10.6666 5.66667 10.6664Z",
    fill: "#0276B1",
    stroke: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.22518d1c1ff3f61e0ad63b61b8394503.svg";
export { ForwardRef as ReactComponent };